import { c as _c } from "react/compiler-runtime";
import { BaseFunnelStepActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/base-funnel-step-actions';
import { OfferFunnelStepActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/offer-funnel-step-actions';
import { RemoteFormFunnelStepActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/remote-form-funnel-step-actions';
import { WebinarRegistrationFunnelStepActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/webinar-registration-funnel-step-actions';
import type { FunnelStepPageActionsProps } from 'modules/funnels/funnel/types/funnel-step-page-actions-props';
import { FunnelStepTypeEnum } from 'shared/enums/funnel-step-type-enum';
function FunnelStepPageActions(props) {
  const $ = _c(12);
  switch (props.funnelStep.type) {
    case FunnelStepTypeEnum.WebinarRegistration:
      {
        let t0;
        if ($[0] !== props) {
          t0 = <WebinarRegistrationFunnelStepActions {...props} />;
          $[0] = props;
          $[1] = t0;
        } else {
          t0 = $[1];
        }
        return t0;
      }
    case FunnelStepTypeEnum.Inline:
    case FunnelStepTypeEnum.Popup:
      {
        let t0;
        if ($[2] !== props) {
          t0 = <RemoteFormFunnelStepActions {...props} />;
          $[2] = props;
          $[3] = t0;
        } else {
          t0 = $[3];
        }
        return t0;
      }
    case FunnelStepTypeEnum.OrderThankYouPage:
    case FunnelStepTypeEnum.Squeeze:
    case FunnelStepTypeEnum.SalesPage:
    case FunnelStepTypeEnum.InfoPage:
    case FunnelStepTypeEnum.OptInThankYouPage:
    case FunnelStepTypeEnum.ContactUsPage:
    case FunnelStepTypeEnum.LinkInBio:
      {
        let t0;
        if ($[4] !== props) {
          t0 = <BaseFunnelStepActions {...props} />;
          $[4] = props;
          $[5] = t0;
        } else {
          t0 = $[5];
        }
        return t0;
      }
    case FunnelStepTypeEnum.WebinarThankYou:
    case FunnelStepTypeEnum.WebinarSession:
      {
        let t0;
        if ($[6] !== props) {
          t0 = <BaseFunnelStepActions {...props} showPreview={true} />;
          $[6] = props;
          $[7] = t0;
        } else {
          t0 = $[7];
        }
        return t0;
      }
    case FunnelStepTypeEnum.OfferForm:
      {
        let t0;
        if ($[8] !== props) {
          t0 = <OfferFunnelStepActions {...props} />;
          $[8] = props;
          $[9] = t0;
        } else {
          t0 = $[9];
        }
        return t0;
      }
    case FunnelStepTypeEnum.Upsell:
    case FunnelStepTypeEnum.Downsell:
      {
        let t0;
        if ($[10] !== props) {
          t0 = <OfferFunnelStepActions {...props} showPreview={true} />;
          $[10] = props;
          $[11] = t0;
        } else {
          t0 = $[11];
        }
        return t0;
      }
    default:
      {
        return null;
      }
  }
}
export { FunnelStepPageActions };